import { useTranslation } from 'react-i18next';

import {
  blockContainer,
  iconWrapperStyle
} from '@/components/ProfileData/Blocks/styles.ts';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import LocationShape from '@/components/common/svg/shapes/LocationShape.tsx';

interface CityBlockProps {
  onOpen: () => void;
}

export const CityBlock = ({ onOpen }: CityBlockProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <div
        style={{
          ...blockContainer,
          cursor: 'pointer'
        }}
        onClick={onOpen}
      >
        <div style={iconWrapperStyle}>
          <LocationShape width={20} height={20} fillColor="#1A1A1A" />
        </div>
        <span
          style={{
            flexGrow: 1,
            textAlign: 'left',
            fontSize: '15px',
            fontWeight: '400',
            color: '#1A1A1A'
          }}
        >
          {t('city_select.label')}
        </span>
        <span
          style={{
            color: '#1A1A1A',
            fontSize: '15px',
            fontWeight: '500',
            marginRight: '10px'
          }}
        >
          {t('city_select.kyiv')}
        </span>
        <ArrowRightShape width={14} height={14} fillColor="#C8C8CB" />
      </div>
    </div>
  );
};
